import { createChannelAccessTokenResponseInterceptor, setChannelAccessToken } from '@lego/auth-toc-web';
import { promiseWithResolver } from '../shims';
import { isBank } from '@/config/core';
import { COUNTRY } from '@/utils/locale';
import { isBankNonLogin } from '../liveChatToken';

enum BankAccountTypeEnum {
  BankPHNonLogin = 104,
  BankIDNonLogin = 105
}
interface IGetAccessTokenResponse { code: number; data: IAuthData }
export let initTocWebPromise: Promise<any> | null;
interface IAuthData { accessToken: string }
let authData: IAuthData | null = null;
let setChannelAccessTokenResponse: any = null;
export function getAuthAccountType() {
  switch (COUNTRY) {
    case 'id':
      return BankAccountTypeEnum.BankIDNonLogin;
    case 'ph':
      return BankAccountTypeEnum.BankPHNonLogin;
    default:
      console.error('[auth, init]~getAccountType, unknown `COUNTRY`', COUNTRY);
      return '' as any;
  }
}
/**
 *
 * reply on initLiveChatSDK
 * @returns
 */
export async function initTocWeb() {
  console.log('[auth, init]~initTocWeb, start init');
  if (setChannelAccessTokenResponse) {
    return setChannelAccessTokenResponse
  }
  if (initTocWebPromise) {
    console.log('[auth, init]~initTocWeb, already exists initTocWebPromise');
    return initTocWebPromise;
  }
  const { promise, resolve, reject } = promiseWithResolver<IGetAccessTokenResponse | null>();
  initTocWebPromise = promise;

  if (!isBank()) {
    resolve(null);
    initTocWebPromise = null;
    authData = null;
    setChannelAccessTokenResponse = null;
    return promise;
  }

  try {
    const { isBankNonLogin } = await import('../liveChatToken');
    if (!isBankNonLogin) {
      resolve(null);
      initTocWebPromise = null;
      authData = null;
      setChannelAccessTokenResponse = null;
      return promise;
    }
    const data = await setChannelAccessToken({
      // TODO:
      // supportAccessTokenAppVersions: ENVIRONMENT === 'live' ? undefined : {
      //   [BankAccountTypeEnum.BankIDNonLogin]: {
      //     IOS: { default: 1 },
      //     Android: { default: 1 }
      //   },
      //   [BankAccountTypeEnum.BankPHNonLogin]: {
      //     IOS: { default: 1 },
      //     Android: { default: 1 }
      //   }
      // },
      accountType: getAuthAccountType(),
      urlPath: '/chat/v2/get_access_token'
    }) as unknown as IGetAccessTokenResponse;
    // console.log('[auth, init]~initTocWeb, data=', data);
    console.log('[auth, init]~initTocWeb, init success, data=', data, authData);
    if (data?.code === 0) {
      setChannelAccessTokenResponse = {
        ...data
      }
      authData = (data as unknown as { code: number; data: IAuthData })?.data;
      initTocWebPromise = promise;
      resolve(data);
    } else {
      // 支持bridge但是接口报错了
      reject(data)
    }
  } catch (e) {
    console.error('[auth, init]~initTocWeb, e=', e);
    // 这里不能使用reject，因为当bridge不支持的时候应该跳过，并且也同时跳过createChannelAccessTokenResponseInterceptor
    resolve(null);
    return promise;
  }

  try {
    if (isBank() && isBankNonLogin) {
      console.log('[auth, init]~initTocWeb, start createChannelAccessTokenResponseInterceptor');
      const { fetch } = await import('../../services/request');
      fetch.interceptors.response.use(
        response => response, // 成功响应时的处理
        createChannelAccessTokenResponseInterceptor({
          accountType: getAuthAccountType(),
          requestInstance: fetch,
          useDetailedError: true,
        }), // 错误响应时的处理
      );
      console.log('[auth, init]~initTocWeb, init createChannelAccessTokenResponseInterceptor success');
    }
  } catch (e) {
    console.error('[auth, init]~createChannelAccessTokenResponseInterceptor, e=', e);
  }
  return promise;
}

export function getAuthData() {
  return authData
}
